import { useState, useEffect } from "react";
import { 
  subscribeToShipments, 
  subscribeToCarriers,
  addShipment,
  updateShipment
} from "../services/logisticsService";

export function useLogistics() {
  const [shipments, setShipments] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribeShipments = () => {};
    let unsubscribeCarriers = () => {};

    try {
      setLoading(true);
      unsubscribeShipments = subscribeToShipments((data, err) => {
        if (err) {
          setError("Failed to load shipments.");
        } else {
          setShipments(data);
        }
        setLoading(false);
      });

      unsubscribeCarriers = subscribeToCarriers((data, err) => {
        if (!err) setCarriers(data);
      });

    } catch (err) {
      console.error(err);
      setError("Failed to initialize logistics subscription.");
      setLoading(false);
    }

    return () => {
      unsubscribeShipments();
      unsubscribeCarriers();
    };
  }, []);

  const handleAddShipment = async (shipmentData) => {
    try {
      setError("");
      return await addShipment(shipmentData);
    } catch (err) {
      console.error("Error adding shipment:", err);
      setError(err.message || "Failed to add shipment.");
      throw err;
    }
  };

  const handleUpdateShipment = async (id, shipmentData) => {
    try {
      setError("");
      await updateShipment(id, shipmentData);
    } catch (err) {
      console.error("Error updating shipment:", err);
      setError(err.message || "Failed to update shipment.");
      throw err;
    }
  };

  return {
    shipments,
    carriers,
    loading,
    error,
    setError,
    addShipment: handleAddShipment,
    updateShipment: handleUpdateShipment
  };
}
